import { FC, RefObject, useCallback, useEffect, useRef } from "react";
import { TextInputProps } from "./types";
import { Column } from "../../containers";
import { AlignItems, JustifyContent } from "../../containers/types";
import { Heading } from "../../typography";
import { useThemeStore } from "../../../stores";

const TextInput: FC<TextInputProps> = ({
  setValue = () => {},
  value,
  label,
  props,
  inputProps,
  className = "",
  style = {},
  color,
  background,
}) => {
  const theme = useThemeStore((state) => state.theme);
  const ref: RefObject<HTMLInputElement> = useRef<HTMLInputElement>(null);

  const handler = useCallback(
    (e: MouseEvent): void => {
      if ((e.target as Element).tagName.toLowerCase() !== "input") {
        ref.current?.blur();
      }
    },
    [ref]
  );

  useEffect(() => {
    window.addEventListener("click", handler);
    return (): void => {
      window.removeEventListener("click", handler);
    };
  }, [handler]);

  return (
    <Column
      alignItems={AlignItems.Start}
      justifyContent={JustifyContent.Start}
      gap={5}
      className={className}
      style={{ width: "100%", ...style }}
      props={props}
    >
      <Heading color={color || theme.textOnOverlay} size={16}>
        {label}
      </Heading>
      <input
        ref={ref}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        style={{
          borderRadius: 15,
          background: background || theme.background,
          width: "calc(100% - 10px)",
          height: 41,
          paddingRight: 10,
          color:
            background === theme.background
              ? theme.textOnBg
              : theme.textOnOverlay,
        }}
        {...inputProps}
      />
    </Column>
  );
};

export default TextInput;
